import { Route, Routes } from 'react-router-dom';
import logo from './logo.svg';
import Safety from './pages/Safety';
import Dashboard from "./pages/Dashboard";
import Map from "./pages/Map";
import { Layout } from './Layout';
import Login from './pages/Login';
import Auth from './Auth';
import Settings from './pages/Settings';

import './App.css';

function App() {
  if (!Auth.getUserToken()) {
    return (
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>);
  }
  return (
    <Layout>
      <Routes>
        <Route exact path="/" element={<Dashboard />} />
        <Route exact path="/Safety" element={<Safety />} />
        <Route exact path="/Dashboard" element={<Dashboard />} />
        <Route exact path="/map" element={<Map />} />
        <Route exact path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

export default App;
